import React, { useCallback, useState } from 'react';

import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';

import { ACCOUNT_CONTENT_PADDING_X } from '../accountLayout';
import { useAccountOfferId } from '../useAccountOfferId';

import CasesAllPage from './CasesAllPage';
import CasesByOwnerPage from './CasesByOwnerPage';
import { CASES_SIDEBAR_LABEL, casePath } from './constants';

const LIST_TABS = [
  { value: 'all', label: 'All Cases' },
  { value: 'owner', label: 'Per Owner' },
] as const;

type ListTab = (typeof LIST_TABS)[number]['value'];

export default function CasesListPage() {
  const { id_account: accountId = '' } = useParams<{ id_account: string }>();
  const offerId = useAccountOfferId();
  const [tab, setTab] = useState<ListTab>('all');

  const buildCaseHref = useCallback(
    (caseNumber: string) => casePath(accountId, offerId, caseNumber),
    [accountId, offerId],
  );

  return (
    <Box sx={{ mx: { xs: -ACCOUNT_CONTENT_PADDING_X.xs, md: -ACCOUNT_CONTENT_PADDING_X.md } }}>
      <Helmet>
        <title>{`${CASES_SIDEBAR_LABEL} · ${accountId}`}</title>
      </Helmet>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tab} onChange={(_, value) => setTab(value)} aria-label="Campaign Operation Cases views">
          {LIST_TABS.map((entry) => (
            <Tab key={entry.value} value={entry.value} label={entry.label} />
          ))}
        </Tabs>
      </Box>
      {tab === 'all' ? (
        <CasesAllPage buildCaseHref={buildCaseHref} />
      ) : (
        <CasesByOwnerPage buildCaseHref={buildCaseHref} />
      )}
    </Box>
  );
}
